const params = new URLSearchParams(window.location.search);
if (params.get('debug-console')) {
    monkeyPatchLogs();
}

function monkeyPatchLogs() {
    const baseLogFunction = console.log;
    console.log = function () {
        baseLogFunction.apply(console, arguments);

        const args = Array.prototype.slice.call(arguments);
        for (let i = 0; i < args.length; i++) {
            const node = createLogNode(args[i]);
            window.document.body?.appendChild(node);
        }
    };

    window.onerror = function (message, url, linenumber) {
        console.log('JavaScript error: ' + message + ' on line ' + linenumber + ' for ' + url);
    };
}

function createLogNode(message) {
    const node = document.createElement('div');
    const textNode = document.createTextNode(message);
    node.appendChild(textNode);
    return node;
}
